<template>
  <div class="wrapper-icon-open-id">
    <GoogleIconSvg />
  </div>
</template>

<script>
  import GoogleIconSvg from '../icons/svg/google.vue'

  export default {
    name: 'RoundGoogleIcon',
    components: {
      GoogleIconSvg
    }
  }
</script>


// WEBPACK FOOTER //
// RoundGoogle.vue?77d40d86